import ApiBaseResponseService from './services/apiBaseResponse';
import apiCampaigns from './services/apiCampaigns';
import apiContacts from './services/apiContacts';
import apiDashboard from './services/apiDashboard';
import apiEmail from './services/apiEmail';
import apiImprint from './services/apiImprint';
import apiInvestors from './services/apiInvestors';
import apiNotifications from './services/apiNotifications';
import apiPicklist from './services/apiPicklist';
import apiSelections from './services/apiSelections';
import apiTasks from './services/apiTasks';
import apiTeam from './services/apiTeam';
import apiUser from './services/apiUser';
import digiCert from './services/digiCert';
import filterHistory from './services/filterHistory';
import genericMethods from './services/genericMethods';
import messageBox from './services/messageBox';
import apiAuthentication from './services/apiAuthentication';
import TaskMutationTrackingService from './services/taskMutationTrackingService';
import apiGroups from './services/apiGroups';
import apiRfps from './services/apiRfps';
import campaignFilterHistory from './services/campaignFilterHistory';
import sentEmailPopup from './services/sentEmailPopup';

export default angular
    .module('advinda.services', [])
    .service('ApiBaseResponseService', ApiBaseResponseService)
    .service('ApiCampaigns', apiCampaigns)
    .service('ApiContacts', apiContacts)
    .service('ApiDashboard', apiDashboard)
    .service('ApiEmail', apiEmail)
    .service('ApiImprint', apiImprint)
    .service('ApiInvestors', apiInvestors)
    .service('ApiNotifications', apiNotifications)
    .service('ApiPicklist', apiPicklist)
    .service('ApiSelections', apiSelections)
    .service('ApiTasks', apiTasks)
    .service('ApiTeam', apiTeam)
    .service('ApiUser', apiUser)
    .service('digiCert', digiCert)
    .service('filterHistory', filterHistory)
    .service('GenericMethods', genericMethods)
    .service('MessageBox', messageBox)
    .service('ApiAuthentication', apiAuthentication)
    .service('TaskMutationTrackingService', TaskMutationTrackingService)
    .service('ApiGroups', apiGroups)
    .service('ApiRfps', apiRfps)
    .service('campaignFilterHistory', campaignFilterHistory)
    .service('sentEmailPopup', sentEmailPopup);



/** WEBPACK FOOTER **
 ** ./src/app/app.services.js
 **/